import {NgxFilterBaseComponent} from "../ngx-filter-base-component";

export abstract class NgxNumberBoxFilter extends NgxFilterBaseComponent {

  get prefixTextForHint(): string {
    if (this.options?.prefixTextForHint) {
      return this.options.prefixTextForHint;
    }
    return ' $';
  }

  get maxLabel(): string {
    if (this.options?.maxLabel) {
      return this.options.maxLabel
    }
    return this.filterService.translator.maxLabel;
  }

  get minimumValue(): string {
    if (this.options?.minLabel) {
      return this.options.minLabel;
    }
    return this.filterService.translator.minimumLabel;
  }

  get isMoney(): boolean {
    return this.options?.isMoney;
  }

  get amount(): string {
    if (this.options?.amountLabel) {
      return this.options.amountLabel
    }
    return this.filterService.translator.amountLabel;
  }
}
